import { useTranslation } from 'react-i18next'

import { SubTitle, Text } from '@/components/common/UI'
import { ConfettiAnimation } from '@/components/custom-components'
import {
    Button,
    Modal as ModalUI,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader
} from '@/components/nextui'

interface ModalProps {
    isOpen: boolean
    onClose: () => void
    text: string
    contentText?: string
    buttonLabel?: string
    newDescription?: boolean
    showInterviewMessage?: boolean
    showPaymentMessage?: boolean
}

export const Modal = ({
    onClose,
    isOpen,
    text,
    contentText,
    buttonLabel = 'ok',
    newDescription,
    showInterviewMessage = false,
    showPaymentMessage = false
}: ModalProps): JSX.Element => {
    const { t } = useTranslation()
    const newText = text

    return (
        <ModalUI
            backdrop="opaque"
            isOpen={isOpen}
            onClose={onClose}
            placement="center"
            motionProps={{
                variants: {
                    enter: {
                        y: 0,
                        opacity: 1,
                        transition: {
                            duration: 0.3,
                            ease: 'easeOut'
                        }
                    },
                    exit: {
                        y: -20,
                        opacity: 0,
                        transition: {
                            duration: 0.2,
                            ease: 'easeIn'
                        }
                    }
                }
            }}
        >
            <ModalContent>
                {(onClose) => (
                    <>
                        <ConfettiAnimation isVisible />
                        <ModalHeader>
                            <SubTitle
                                subTitle={
                                    showInterviewMessage
                                        ? t(`${newText}.interviewTitle`)
                                        : t(`${newText}.title`)
                                }
                                className="text-primary"
                            />
                        </ModalHeader>
                        <ModalBody>
                            {showPaymentMessage ? (
                                <Text text="Finalizaste tu proceso de admisión, el paso a seguir es que realices el pago de tu matrícula." />
                            ) : showInterviewMessage ? (
                                <Text
                                    text={t(`${newText}.interviewDescription`)}
                                />
                            ) : (
                                <>
                                    <Text
                                        text={
                                            newDescription
                                                ? t(`${newText}.newDescription`)
                                                : t(`${newText}.description`)
                                        }
                                    />
                                    {contentText && (
                                        <Text
                                            text={contentText}
                                            className="font-bold"
                                        />
                                    )}
                                </>
                            )}
                        </ModalBody>
                        <ModalFooter className="flex justify-center">
                            <Button
                                color="primary"
                                onPress={onClose}
                            >
                                {t(buttonLabel)}
                            </Button>
                        </ModalFooter>
                    </>
                )}
            </ModalContent>
        </ModalUI>
    )
}
